import React from 'react';
import Typography from './Typography';

export type HeadingProps = {
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  size?: 'xl' | 'lg' | 'md' | 'sm';
  variant?: 'primary' | 'secondary';
  className?: string;
  id?: string;
  children: React.ReactNode;
};

const sizeToVariantMap = {
  xl: 'h1' as const,
  lg: 'h2' as const,
  md: 'h3' as const,
  sm: 'h4' as const,
};

const variantToColorMap = {
  primary: 'primary' as const,
  secondary: 'accent' as const,
};

export const Heading: React.FC<HeadingProps> = ({
  as = 'h2',
  size = 'md',
  variant = 'primary',
  className = '',
  id,
  children,
}) => {
  return (
    <Typography
      variant={sizeToVariantMap[size]}
      as={as}
      color={variantToColorMap[variant]}
      className={className}
      id={id}
    >
      {children}
    </Typography>
  );
};

export default Heading; 